import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { SlotController } from 'src/components/controllers/slot-controller';
import { MobileController } from '../../controllers/mobile-controller';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './idb-table.css.lit';

/**
 * The IdbTable component
 * @element idb-table
 * @slot - The default slot to render a `table` element in.
 */
@customElement('idb-table')
export class IdbTable extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  @property({ type: Boolean, attribute: 'mobile-accordion' })
  mobileAccordion: false;

  @property({ type: Boolean, attribute: 'column-sticky' })
  columnSticky: false;

  protected mobileController = new MobileController(this);

  render(): TemplateResult {
    const tableClasses = {
      'table-wrapper': true,
      'table-wrapper--sticky': this.columnSticky,
      'mobile-accordions':
        this.mobileController.isMobile && this.mobileAccordion,
    };

    return html`
    <div class=${classMap(tableClasses)}>
      ${
        this.mobileController.isMobile && this.mobileAccordion
          ? html`<slot name="accordion"></slot>`
          : html`<slot name="table"></slot>`
      }
    </div>
    `;
  }
}
